(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["holy-product-total"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('holy-product-total')) {
    customElements.define('holy-product-total', class extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        this.component = this.closest('[data-js-product-component]');
        this.quantityInput = this.form?.querySelector('input[name="quantity"]');
        this.labelOutput = this.querySelector('[data-holy-total-label]');
        this.priceOutput = this.querySelector('[data-holy-total-price]');
        this.prices = JSON.parse(this.querySelector('[data-holy-product-prices]').textContent);
        this.updateSoon = () => requestAnimationFrame(() => this.update());

        this.quantityInput?.addEventListener('input', this.updateSoon);
        this.quantityInput?.addEventListener('change', this.updateSoon);
        this.component?.addEventListener('click', this.updateSoon);
        this.component?.addEventListener('change', this.updateSoon);

        this.observer = new MutationObserver(this.updateSoon);
        if (this.form) {
          this.observer.observe(this.form, { childList: true, subtree: true, attributes: true, attributeFilter: ['value'] });
        }

        this.update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      update() {
        const quantity = Math.max(1, Number.parseInt(this.quantityInput?.value || '1', 10));
        const sellingPlanId = this.form?.querySelector('[name="selling_plan"]')?.value;
        const unitPrice = this.prices.plans[sellingPlanId] || this.prices.oneTime;
        const total = unitPrice * quantity / 100;

        this.labelOutput.textContent = this.dataset.labelTemplate.replace('__COUNT__', quantity);
        this.priceOutput.textContent = new Intl.NumberFormat(this.dataset.locale || 'fr', {
          style: 'currency',
          currency: this.dataset.currency || 'EUR'
        }).format(total);
        this.hidden = quantity < 2;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
